// Rova: tell Google Analytics when someone submits a Klaviyo sign-up form (event: sign_up)
window.addEventListener('klaviyoForms', function (e) {
  if (e.detail && e.detail.type === 'submit' && typeof window.gtag === 'function') {
    window.gtag('event', 'sign_up', { method: 'Klaviyo form', form_id: e.detail.formId, send_to: 'G-KH6K0KS9RH' });
  }
});
